import { stringify } from "qs";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import type { BaseFilter } from "./contexts/types";

export const useSyncFiltersToUrl = <T = BaseFilter[]>(state: T) => {
  const history = useHistory();

  useEffect(() => {
    // We cannot simply rely on state and history for this useEffect to be triggered
    // because it will trigger too often resulting in infinite re-renders.
    // Instead, we compare the current search with the new search and only update
    // the url if they are different.
    const newSearch = stringify(state);
    const currentSearch = history.location.search.replace(/^\?/, "");

    if (newSearch !== currentSearch) {
      history.replace({
        pathname: history.location.pathname,
        search: newSearch,
      });
    }
  }, [state, history]);
};
